<div>
    <mat-expansion-panel [expanded]="panelItem.Sequence === expandPanelNumber" (opened)="openedPanel()"
        (closed)="expanded = false" [ngClass]="{'active-panel': expanded}" [disabled]="isPanelBodyEmpty">
        <mat-expansion-panel-header
            [ngClass]="{'bold-text': isBanner || expanded, 'disabled-cursor': isPanelBodyEmpty, 'dashboard-panel': isBanner}">
            <div [fxLayoutAlign]="isPanelFixedWidth ? 'center center' : 'space-between'" fxFlex>
                <ng-container *ngIf="!isPanelBodyEmpty && !isIconRightOriented">

                    <mat-icon *ngIf="expanded && closeIcon" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''"> {{closeIcon}}</mat-icon>
                    <mat-icon *ngIf="!expanded && closeIcon" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''">
                        {{openIcon}}
                    </mat-icon>
                    <mat-icon *ngIf="!closeIcon" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''" [@iconRotator]="expanded ? 'expanded': 'collapsed'">
                        {{openIcon}}
                    </mat-icon>
                    <span class="icon-caption" [innerHTML]="panelItem.IconCaption"
                        *ngIf="panelItem.IconCaption!='' && !expanded"></span>
                </ng-container>
                <div><img *ngIf="panelItem.IconClass !=''" [src]="resourceService.getImage(panelItem.IconClass)"
                        alt="{{panelItem.IconClass}}" /></div>
                <adp-panel-item class="mat-expansion-panel-header-item" *ngIf="isPanelFixedWidth" [panelKey]="panelKey"
                    [panelItemKey]="panelItem.Title" [field]="panelItem.Header"></adp-panel-item>
                <adp-panel-item class="mat-expansion-panel-header-item" *ngIf="!isPanelFixedWidth" fxFlex
                    [panelKey]="panelKey" [panelItemKey]="panelItem.Title" [field]="panelItem.Header"></adp-panel-item>
                <ng-container *ngIf="!isPanelBodyEmpty && isIconRightOriented">
                    <span class="icon-caption" [innerHTML]="panelItem.IconCaption"
                        *ngIf="panelItem.IconCaption!='' && !expanded"></span>
                    <mat-icon *ngIf="closeIcon && !expanded" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''">
                        {{openIcon}}
                    </mat-icon>
                    <mat-icon *ngIf="closeIcon && expanded" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''">
                        {{closeIcon}}
                    </mat-icon>
                    <mat-icon *ngIf="!closeIcon" [ngClass]="{'mat-icon-padding': expanded && isBanner}"
                        [color]="!expanded ? 'primary' : ''" [@iconRotator]="expanded ? 'expanded': 'collapsed'">
                        {{openIcon}}
                    </mat-icon>
                </ng-container>
            </div>
        </mat-expansion-panel-header>

        <div *ngIf="!isPanelBodyEmpty" class="mat-expansion-panel-body">
            <div class="mat-expansion-panel-body-item ">
                <span class="panel-content" [ngClass]="{'panel-body-leftAlign': isBodyLeftAligned}"
                    [innerHTML]="panelItem.Body | safeHtml"></span>
            </div>
        </div>
    </mat-expansion-panel>
</div>